import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';
import { FONT_SIZE } from '../TextBox/constants';

const Note = ({ children, options }: Props) => React.createElement(TextBox, { children, options, size: FONT_SIZE.SMALL });

export default Note;